var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLynxLogomarkBwRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D1D3D4;}\r\n\t.st1{fill:#BCBEC0;}\r\n\t.st2{fill:#A7A9AC;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "241.47,233.21 241.47,224.06 223.1,224.06 223.1,276.87 232.32,276.87 232.32,233.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "276.68,214.91 241.47,214.91 241.47,224.06 258.3,224.06 258.3,233.21 267.52,233.21 267.52,267.72  276.68,267.72  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.47,
    y: 224.06,
    className: "st1",
    width: 16.83,
    height: 9.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "258.3,276.87 232.32,276.87 232.32,286.02 267.52,286.02 267.52,267.72 258.3,267.72  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.3,
    y: 233.21,
    className: "st1",
    width: 9.22,
    height: 34.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.47,
    y: 233.21,
    className: "st2",
    width: 16.83,
    height: 34.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLynxLogomarkBwRgb);
export default __webpack_public_path__ + "static/media/Lynx-logomark-bw-rgb.7e9f208876440888af897ab44d9b7e39.svg";
export { ForwardRef as ReactComponent };